import {fetch} from "../../../utils/dataAccess";

export function getWMSPickingMissionModels(currentInventoryId) {
    return new Promise((resolve, reject) => {
        fetch("/w_m_s_picking_mission_models?inventoryId="+currentInventoryId, {})
            .then((response) => {
                response.json().then(retrieved => {
                    resolve(retrieved["hydra:member"])
                })
            })
            .catch(error => reject(error))
    })
}

export function getWMSPickingMissionModel(modelId) {
    return new Promise((resolve, reject) => {
        fetch(`/w_m_s_picking_mission_models/${modelId}`)
            .then((response) => {
                response.json().then(retrieved => {
                    resolve(retrieved)
                })
            })
            .catch(error => reject(error))
    })
}